/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import * as FileSaver from 'file-saver'
import { gtag } from 'ga-gtag'
import jwtDecode from 'jwt-decode'
import _debounce from 'lodash/debounce'
import geet from 'lodash/get'
import isempty from 'lodash/isEmpty'
import _noop from 'lodash/noop'
import _set from 'lodash/set'
import triim from 'lodash/trim'
import moment from 'moment'
import queryString from 'query-string'
import * as XLSX from 'xlsx'

import { DATEFORMAT, URN_TEMPLATE } from './constants'

export const desc = function (a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}
export const stableSort = function (array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

export const getSorting = function (order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy)
}
export const getQueryData = function () {
  return queryString.parse(location.search)
}

export const handleChangeRowsPerPage = function (event, pageDetails, callBack) {
  pageDetails.per_page = parseInt(event.target.value, 10)
  pageDetails.current_page = 1
  callBack()
}

export const handleChangePage = function (event, newPage, pageDetails, callBack) {
  pageDetails.current_page = newPage
  callBack()
}
export const setPageDetailsData = function (data, pageDetails, setPageDetails) {
  pageDetails.current_page = data.current_page || data.currentPage
  pageDetails.from = data.from
  pageDetails.last_page = data.last_page || data.lastPage
  pageDetails.per_page = Number(data.per_page) || data.perPage
  pageDetails.to = data.to
  pageDetails.total = data.total
  setPageDetails({ ...pageDetails })
}

type getSchoolUrlProp = {
  district: string
  school: string
  to: string
}
export const getSchoolUrl = function ({ district, school, to }: getSchoolUrlProp): string {
  return `/${district || ''}/${school || ''}/${to || ''}`.replace(/\/\//g, '/')
}

export const isTokenValid = (jwt, minutes = 2) => {
  const decodedToken = jwtDecode(jwt)
  const exp = moment.unix(decodedToken.exp)
  const utc = moment.utc()
  const diff = exp.diff(utc, 'minutes')
  return diff > minutes
}

export const isUnauthRoute = function () {
  return (
    window.location.pathname === '/' ||
    window.location.pathname.includes('login') ||
    window.location.pathname.includes('register') ||
    window.location.pathname.includes('passwordreset') ||
    window.location.pathname.includes('allprograms') ||
    window.location.pathname.includes('schoolstore') ||
    window.location.pathname.includes('surveys') ||
    window.location.pathname.includes('programdetailsopen') ||
    window.location.pathname.includes('programreviews') ||
    window.location.pathname.includes('coursereviews') ||
    window.location.pathname.includes('accessibleprograms')
  )
}

export const trimmer = function (data) {
  if (!isempty(data)) {
    if (typeof data === 'object' && !Array.isArray(data)) {
      let trimedValues = {}
      Object.entries(data).forEach((value) => {
        if (typeof value[1] === 'string') {
          trimedValues = { ...trimedValues, [value[0]]: value[1].trim() }
        } else if (typeof value[1] === 'object') {
          const valueObj = trimmer(value[1])
          trimedValues = { ...trimedValues, [value[0]]: valueObj }
        } else {
          trimedValues = { ...trimedValues, [value[0]]: value[1] }
        }
      })
      return trimedValues
    } else if (typeof data === 'object' && Array.isArray(data)) {
      const trimedValues = []
      data.forEach((arrayValue) => {
        if (typeof arrayValue === 'string') {
          trimedValues.push(arrayValue.trim())
        } else if (typeof arrayValue === 'object') {
          const valueObj = trimmer(arrayValue)
          trimedValues.push(valueObj)
        } else {
          trimedValues.push(arrayValue)
        }
      })
      return trimedValues
    }
  } else {
    return data
  }
}

export const getOffsetInInt = function (rawOffset) {
  if (!rawOffset || (!rawOffset.includes('+') && !rawOffset.includes('-'))) {
    return 0
  }
  if (rawOffset.includes('+')) {
    let offsetPart = rawOffset.split('+')[1]
    offsetPart = offsetPart.split(':')
    return parseInt(offsetPart[0]) * 60 + parseInt(offsetPart[1])
  }
  if (rawOffset.includes('-')) {
    let offsetPart = rawOffset.split('-')[1]
    offsetPart = offsetPart.split(':')
    return -(parseInt(offsetPart[0]) * 60 + parseInt(offsetPart[1]))
  }
}
export const getDate = function (timeStamp) {
  const d = new Date(timeStamp)
  return d.toLocaleString()
}
export const getDateInUserTimezone = function (date, originalOffset, format) {
  const currentSystemOffset = -new Date().getTimezoneOffset()
  const orifinalOffsetFormatted = getOffsetInInt(originalOffset)
  date = moment(date)
    .subtract(orifinalOffsetFormatted, 'minutes')
    .add(currentSystemOffset, 'minutes')
  return format ? date.format(format) : date
}

export const convertTimestampToDate = function (timeStamp) {
  const date = moment.unix(timeStamp / 1000).format(DATEFORMAT)
  return date.toLocaleString()
}

export const isNullOrEmpty = function (value) {
  return value === null || value === undefined || value === ''
}

export const mapWithState = function (initialState, value) {
  const obj = {}
  Object.keys(initialState).forEach((key) => {
    obj[key] = !isNullOrEmpty(value[key]) ? value[key] : initialState[key]
  })
  return obj
}

export const applySchoolTheme = function (theme) {
  if (!theme) {
    return
  }
  document.body.setAttribute('data-theme', theme)
}

export const addFrontSlash = function (path) {
  if (path[0] !== '/') {
    return `/${path}`
  }
  return path
}

export const removeBackSlash = function (path) {
  if (path[path.length - 1] === '/') {
    return path.substr(0, path.length - 1)
  }
  return path
}

export const makeFakeEvent = function (data) {
  return {
    target: {
      ...data,
    },
  }
}

export const makeFakeCurrentTargetEvent = function (data) {
  return {
    currentTarget: {
      attributes: { ...data },
    },
  }
}

export const mapStateWithData = function (data, initialState) {
  const obj = {}
  Object.keys(initialState).forEach((key) => {
    obj[key] = data[key] ? data[key] : initialState[key]
  })
  return obj
}

export const calculateAge = function (birthday) {
  // birthday is a date
  const birthDayModified = typeof birthday === 'object' ? birthday.getTime() : birthday
  const ageDifMs = Date.now() - birthDayModified
  const ageDate = new Date(ageDifMs) // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970)
}

export const getAccountIdFromToken = function (token) {
  try {
    const decodedToken = jwtDecode(token)
    const urnParam = decodedToken.iss.match(URN_TEMPLATE)[3]
    return urnParam.substring(0, urnParam.indexOf('/'))
  } catch {
    return ''
  }
}

export const getSchoolIDFromToken = function (token) {
  try {
    const decodedToken = jwtDecode(token)
    const urnParam = decodedToken.iss.match(URN_TEMPLATE)[3]
    return urnParam.substring(urnParam.indexOf('/') + 1, urnParam.length)
  } catch {
    return ''
  }
}

export const generateGreetings = function () {
  const currentHour = moment().format('HH')
  if (currentHour >= 3 && currentHour < 12) {
    return 'morning'
  } else if (currentHour >= 12 && currentHour < 15) {
    return 'afternoon'
  } else {
    return 'evening'
  }
}

export const exportToCSV = (mappedRequests, fileName) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const fileExtension = '.xlsx'
  const ws = XLSX.utils.json_to_sheet(mappedRequests)
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const data = new Blob([excelBuffer], { type: fileType })
  FileSaver.saveAs(data, fileName + fileExtension)
}

export const checkRegisterationState = function (user, metadata) {
  const requiredValues = {
    first_name: user?.first_name,
    last_name: user?.last_name,
    dob: user?.dob,
    email: user?.email,
    adr_country_iso: user?.address?.adr_country_iso,
    adr_state_iso: user?.address?.adr_state_iso,
    adr_city: user?.address?.adr_city,
    adr_zipcode: user?.address?.adr_zipcode,
    adr_address1: user?.address?.adr_address1,
  }
  let result = {}
  if (Object.values(requiredValues).some((v) => isNullOrEmpty(v))) {
    result = {
      mainStep: 'studentInfoTab',
      studentStep: 0,
      parentStep: 0,
    }
  } else if (
    user.age < parseInt(metadata.student_age_for_parent_info) &&
    (user.parents || []).length === 0
  ) {
    result = {
      mainStep: 'parentInfoTab',
      studentStep: 2,
      parentStep: 0,
    }
  } else if (metadata.enable_essay && !user.essay && !user?.manual_registered) {
    result = {
      mainStep: 'essayTab',
      studentStep: 2,
      parentStep: 2,
    }
  }
  return result
}

export const checkObjectValueEmpty = (object) => {
  return Object.values(object).some((value) => {
    const isValueEmpty = isNullOrEmpty(value)
    return !isValueEmpty
  })
}
export const enrolledMap = {
  enrolled: {
    resource: 'enrolled',
    style: 'label-enrolled',
  },
  pending_payment: {
    resource: 'pending',
    style: 'label-pending-payment',
  },
  declined_payment: {
    resource: 'declined',
    style: 'label-declined-payment',
  },
  locked: {
    resource: 'locked',
    style: 'label-locked',
  },
  dropped: {
    resource: 'dropped',
    style: 'label-dropped',
  },
  graduated: {
    resource: 'graduated',
    style: 'label-graduated',
  },
  transferred: {
    resource: 'transferred',
    style: 'label-transferred',
  },
  request_for_transfer: {
    resource: 'requestForTransfer',
    style: 'label-request-for-transfer',
  },
  passed: {
    resource: 'passed',
    style: 'label-passed',
  },
  failed: {
    resource: 'failed',
    style: 'label-failed',
  },
  in_evaluation: {
    resource: 'inEvaluation',
    style: 'label-in-evaluation',
  },
  hold: {
    resource: 'hold',
    style: 'label-hold',
  },
  rejected: {
    resource: 'rejected',
    style: 'label-rejected',
  },
  in_print_office: {
    resource: 'inPrintOffice',
    style: 'label-in-print-office',
  },
  package_preparation: {
    resource: 'packagePreparation',
    style: 'label-package-preparation',
  },
  printed: {
    resource: 'printed',
    style: 'label-printed',
  },
  academic_hold: {
    resource: 'academicHold',
    style: 'label-academic_hold',
  },
  attendance_hold: {
    resource: 'attendanceHold',
    style: 'label-attendance_hold',
  },
  billing_hold: {
    resource: 'billingHold',
    style: 'label-billing_hold',
  },
  immunization_record_hold: {
    resource: 'immunizationRecordHold',
    style: 'label-billing_hold',
  },
  completed: {
    resource: 'completed',
    style: 'label-completed',
  },
  expired: {
    resource: 'expired',
    style: 'label-expired',
  },
  grad_evaluation: {
    resource: 'gradEvaluation',
    style: 'label-grad_evaluation',
  },
  graduation_hold: {
    resource: 'graduationHold',
    style: 'label-graduation_hold',
  },
  ineligible: {
    resource: 'ineligible',
    style: 'label-ineligible',
  },
  new_unprocessed: {
    resource: 'newUnprocessed',
    style: 'label-new_unprocessed',
  },
  ready_for_re_enrollment: {
    resource: 'readyForReEnrollment',
    style: 'label-ready_for_re_enrollment',
  },
  processing_payment: {
    resource: 'processingPayment',
    style: 'label-ready_for_re_enrollment',
  },
  graduation_review: {
    resource: 'graduationReview',
    style: 'label-graduation_review',
  },
  canceled: {
    resource: 'canceled',
    style: 'label-canceled',
  },
  application: {
    resource: 'application',
    style: 'label-application',
  },
  pre_requisite: {
    resource: 'pre_requisite',
    style: 'label-pre_requisite',
  },
  pre_req_completed: {
    resource: 'pre_req_completed',
    style: 'label-pre_req_completed',
  },
}

export const notificationTimeInDHM = function (end) {
  const duration = moment.duration(moment().diff(moment(end)))
  const days = Math.floor(duration.asDays())
  duration.subtract(moment.duration(days, 'days'))
  const hours = duration.hours()
  duration.subtract(moment.duration(hours, 'hours'))
  const minutes = duration.minutes()
  if (duration._milliseconds <= 0) {
    return '0 days 0 hours 0 minutes ago'
  } else if (!days) {
    if (!hours) {
      if (!minutes) {
        return `few moments ago`
      } else return `${minutes} minutes ago`
    } else if (!minutes) {
      return `${hours} hours ago`
    } else return `${hours} hours ${minutes} minutes ago`
  } else if (!hours) {
    if (!minutes) {
      return `${days} days ago`
    } else return `${days} days ${minutes} minutes ago`
  } else if (!minutes) {
    return `${days} days ${hours} hours ago`
  } else return `${days} days ${hours} hours ${minutes} minutes ago`
}

export const userProfileCompleteness = {
  avatar: 5,
  prefix: 5,
  first_name: 5,
  middle_name: 4,
  last_name: 5,
  suffix: 4,
  nick_name: 5,
  dob: 5,
  gender: 5,
  ethnicity: 5,
  adr_address1: 5,
  adr_address2: 4,
  adr_country_name: 5,
  adr_state_name: 5,
  adr_city: 4,
  adr_zipcode: 4,
  email: 5,
  adr_mobile_prefix: 3,
  adr_mobile: 4,
  adr_phone_prefix: 4,
  adr_phone: 4,
  upload_id: 5,
}

export const isEmpty = isempty

export const isEnter = (event) => event.keyCode === 13

export const get = geet

export const trim = triim

export const set = _set

export const noop = _noop

export const debounce = _debounce

export const getFullName = function ({ first_name = '', middle_name = '', last_name = '' }) {
  return `${first_name} ${middle_name} ${last_name}`.replace(/  +/g, ' ')
}
export const getCustomerFullName = function ({
  customer_first_name = '',
  customer_middle_name = '',
  customer_last_name = '',
}) {
  return `${customer_first_name} ${customer_middle_name} ${customer_last_name}`.replace(/  +/g, ' ')
}
export const getDashAddedPhone = (phoneNum) => {
  return phoneNum
    ? phoneNum
        .split('')
        .map((e, i) => ((i + 1) % 3 === 0 && i + 1 !== 9 ? e + '-' : e))
        .join('')
    : ''
}
export const getDashRemovedPhone = (phoneNum) => {
  return phoneNum ? phoneNum.split('-').join('') : ''
}

export const extractTextFromHTML = (htmlString) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  return doc.body.textContent || ''
}

export const downloadOrPreviewFiles = (e) => {
  const fileName = e.currentTarget.attributes['data-id'].value || ''
  const fileExtension = fileName?.split('.')?.at(-1)?.toLowerCase()
  const previewFileTypes = ['jpg', 'png', 'pdf', 'jpeg', 'txt']

  if (previewFileTypes.includes(fileExtension)) {
    return window.open(fileName)
  } else {
    const id = e.currentTarget.attributes['data-id'].value
    const element = document.createElement('a')
    element.setAttribute('href', id)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }
}

export const getSchoolAddress = (school = {}) => {
  let add = school.adr_address1
  if (school.adr_address2) {
    add += `, ${school.adr_address2}`
  }
  if (school.adr_city) {
    add += `, ${school.adr_city}`
  }
  if (school.adr_state_name) {
    add += `, ${school.adr_state_name}`
  }
  if (school.adr_zipcode) {
    add += `, ${school.adr_zipcode}`
  }
  if (school.adr_country_name) {
    add += `, ${school.adr_country_name}`
  }
  return add
}

export const dataURIToBlob = (dataURI) => {
  // return new Promise(function (resolve, reject) {
  //   if (URI == null) return reject()
  //   var canvas = document.createElement('canvas'),
  //     context = canvas.getContext('2d'),
  //     image = new Image()
  //   image.addEventListener(
  //     'load',
  //     function () {
  //       canvas.width = image.width
  //       canvas.height = image.height
  //       context.drawImage(image, 0, 0, canvas.width, canvas.height)
  //       resolve(context.getImageData(0, 0, canvas.width, canvas.height))
  //     },
  //     false
  //   )
  //   image.src = URI
  // })
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = window.atob(dataURI.split(',')[1])

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  //Old Code
  //write the ArrayBuffer to a blob, and you're done
  //var bb = new BlobBuilder();
  //bb.append(ab);
  //return bb.getBlob(mimeString);

  //New Code
  return new Blob([ab], { type: mimeString })
}

export const modifyArrayClass = () => {
  Object.defineProperty(Array.prototype, 'touched', {
    value: false,
    writable: true,
  })
}

export const formatDate = (date, format) => {
  return !isNullOrEmpty(date) ? moment(date).format(format) : ''
}

export const formatDateToISO = (date) => {
  return moment(date).toISOString()
}

export const readInfoFromURN = (urn) => {
  return urn.substring(urn.indexOf('::') + 2).split('/')
}

export const raiseGAEvent = (event, event_type, payload) => {
  gtag(event, event_type, payload)
}

export const getPercentage = (percent, total) => {
  const percentage = Math.round((percent / total) * 100)
  return (percentage || 0).toFixed(2)
}

export const calculateSum = (array, property) => {
  const total = array.reduce((accumulator, object) => {
    if (property) {
      return accumulator + Number(object[property] || '0')
    } else {
      return accumulator + Number(object || '0')
    }
  }, 0)
  return total.toFixed(2)
}

export const headerHeight = '500'
export const threadeHeaderdHeight = '420'
